export const px2rem = (px) => {
  if (/%/gi.test(px)) {
    // 有百分号%，特殊处理，表述pc是一个有百分号的数，比如：90%
    return px;
  } else {
    return parseFloat(px) / 75 + 'rem'; // 这里的75，和postcss.config.js里的rootValue值对应
  }
};
/**
 * 防抖
 * @param {f} fn 
 * @param {*} delay 
 * @returns 
 */
export const debounce = (fn, delay) => {
  let timeout;
  return function (...args) {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
};

export const getDeviceAndBrowser = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  // 判断安卓设备
  const isAndroid = userAgent.indexOf('android') > -1;

  //判断鸿蒙系统
  const isHarmony = userAgent.indexOf('ohos') > -1;

  // 判断苹果设备
  const isIos = userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1 || userAgent.indexOf('ipod') > -1;
  // 判断微信浏览器
  const isWeixin = userAgent.indexOf('micromessenger') > -1;
  // 判断safari浏览器
  const isSafari = /Safari/i.test(userAgent) && !/CriOS/i.test(userAgent) && !/Chrome/i.test(userAgent) && !/360ee/.test(userAgent) && !/mqqbrowser/i.test(userAgent)

  let deviceType = 'unknown';
  if (isAndroid) {
    deviceType = 'android';
  } else if (isIos) {
    deviceType = 'ios';
  } else if (isHarmony) {
    deviceType = 'harmony';
  }
  let browserType = 'browser'
  if(isWeixin) {
    browserType = 'weixin'
  }else if(isSafari) {
    browserType = 'safari'
  } else {
    browserType = 'browser'
  }
  let isBookmark = false
  isBookmark = window.navigator.standalone === true

  return {
    deviceType: deviceType, // 'android' 或 'ios'
    browserType: browserType, // 'weixin' 或 'browser'
    isBookmark: isBookmark
  };
};

/**
 * 
 * @param {*} requests 
 * @returns 
 */
export const fetchAllRequests = async (requests) => {
  try {
    const results = await Promise.all(requests);
    return results;
  } catch (error) {
    // 处理任何一个请求失败时的错误
    console.error("请求失败:", error);
    throw error; // 重新抛出错误，以便调用者可以处理
  }
}




//////////////////
// WEBPACK FOOTER
// ./libs/utils.js
// module id = null
// module chunks = 